import * as ActionTypes from '../actions/UiActions';

export const ui = (
  state = {
    all_calls: {},
  },
  action
) => {
  switch (action.type) {
    case ActionTypes.UPDATE_ALL_CALLS_UI_STATE:
      return {
        ...state,
        all_calls: {
          ...state.all_calls,
          ...action.updates,
        },
      };

    default:
      return state;
  }
};
